/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_HelpInputs */



/**
* | output |
* | --- |
* | "Randomly draw winners from a pool of players." |
*
* @param {Raffle_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_help = /** @type {((inputs?: Raffle_HelpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_HelpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tire au sort des gagnants au hasard dans un groupe de joueurs.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sortea ganadores al azar de un grupo de jugadores.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sorteia vencedores aleatoriamente entre um grupo de jogadores.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrae vincitori a caso da un gruppo di giocatori.")
	return /** @type {LocalizedString} */ ("Randomly draw winners from a pool of players.")
});